import React from "react";
import DataTable from "react-data-table-component";
import { Spinner, Row, Col } from "react-bootstrap";
import { IOrder } from "common/types";
import ExpandedStudentPaidOrder from "./ExpandedStudentPaidOrder";

interface StudentPaidOrdersListProps {
  orders: IOrder[];
  loading: boolean;
}

function StudentPaidOrdersList({
  orders,
  loading,
}: StudentPaidOrdersListProps) {
  if (loading) {
    return <Spinner />;
  }

  const sortedOrders = [...orders].sort(
    (a, b) =>
      new Date(b.created_at).getTime() - new Date(a.created_at).getTime(),
  );

  if (sortedOrders.length === 0) {
    return (
      <Row className="mt-4">
        <Col lg={12}>
          <h4 className="mb-4">
            Moje plaćene narudžbe priprema za državnu maturu
          </h4>
          <p>Trenutno nemate plaćenih narudžbi priprema za državnu maturu.</p>
        </Col>
      </Row>
    );
  }

  const columns = [
    {
      id: "created_at",
      name: "Datum kreiranja",
      selector: (row: IOrder) => row.created_at,
      sortable: true,
      omit: true,
      sortFunction: (rowA: IOrder, rowB: IOrder) =>
        new Date(rowA.created_at).getTime() -
        new Date(rowB.created_at).getTime(),
    },
    {
      name: "Ime",
      selector: (row: IOrder) => row.customer.first_name,
      sortable: true,
    },
    {
      name: "Prezime",
      selector: (row: IOrder) => row.customer.last_name,
      sortable: true,
    },
    {
      name: "Grupa priprema",
      selector: (row: IOrder) => row.course.title,
      sortable: true,
    },
    {
      name: "Iznos",
      selector: (row: IOrder) => `${row.amount} EUR`,
      sortable: true,
    },
    {
      name: "Datum plaćanja",
      selector: (row: IOrder) =>
        row.date_paid ? new Date(row.date_paid).toLocaleString("hr-HR") : "-",
      sortable: true,
    },
  ];

  const ExpandedComponent = ({ data }: { data: IOrder }) => (
    <ExpandedStudentPaidOrder data={data} />
  );

  return (
    <Row className="mt-4">
      <Col lg={12}>
        <h4 className="mb-4">Moje plaćene narudžbe državne mature</h4>
        <DataTable
          columns={columns}
          data={sortedOrders}
          defaultSortFieldId="created_at"
          defaultSortAsc={false}
          pagination
          highlightOnHover
          expandableRows
          expandableRowsComponent={ExpandedComponent}
          noDataComponent="Ne postoje plaćene narudžbe"
        />
      </Col>
    </Row>
  );
}

export default StudentPaidOrdersList;
